import React, { useRef, useEffect, useCallback, useState} from 'react';
import {auditionPreset} from 'operations/actions.js';
import {isSynth} from 'utils/trackTypes.js';
import Colors from "components/Colors.js";
import {connect} from 'react-redux';
import {
    setPresetDragging,
    setSampleDragging} from 'actions/index.js';
import AudioUnit from "engine/audio.js";
const colors = new Colors();


const PackContent = ({
    isCurrent,
    sample,
    preset,
    onDelete,
    setSampleDragging,
    setPresetDragging,
    sequencerEngine,
    setIsCurrent,
    isSelected,
    isEditing=true
}) => { 
    let name = undefined;
    let isPlaying = useRef(false);
    if (sample) {
        name = sample.name;
    } else {
        name = preset.title;
    }
    let [audioUnit, setAudioUnit] = useState(undefined);

    useEffect(() => {
        if (isCurrent) {
            if (audioUnit) {
                audioUnit.playSound();
            }
            window.addEventListener("keydown", onKeyDown);
        } else {
            window.removeEventListener("keydown", onKeyDown);
            if (audioUnit) {
                audioUnit.stopSound();
            }
        }
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [isCurrent, audioUnit, sample]);

    const onKeyDown = useCallback((e) => {
        if (!isCurrent) {
            return;
        }
        if (e.key === "Enter" && audioUnit && sample) {
            sequencerEngine.addSound(sample);
        } else if (e.key === "Backspace") {
            if (audioUnit) {
                audioUnit.stopSound();
            }
        }
    }, [audioUnit, sample, isCurrent]);
    
    useEffect(() => {
        if (!sample) { return undefined; }
        let _audioUnit = undefined;
        if (!sample.audioBuffer) {
            sample.load().then(
                () => {
                    _audioUnit = new AudioUnit();
                    _audioUnit.setBuffer(sample.audioBuffer);
                    setAudioUnit(_audioUnit);
                });
        } else {
            _audioUnit = new AudioUnit();
            _audioUnit.setBuffer(sample.audioBuffer);
            setAudioUnit(_audioUnit);
        }

        return () => _audioUnit ? _audioUnit.dispose() : 0;
    }, []);

    const onMouseDown = useCallback(() => {
        if (!audioUnit) { return; }
        audioUnit.playSound();
        isPlaying.current = true;
        setIsCurrent();
    }, [audioUnit]);

    const onMouseUp = useCallback((isLeave) => {
        if (preset && !isLeave) {
            // check the current track is a synth
            let track = sequencerEngine.getSelectedTrack();
            // TODO: check that track has same type as preset type 
            if (track && isSynth(track)) {
                sequencerEngine.operationManager.dispatch(
                    auditionPreset(
                        preset,
                        track,
                        true,
                        false));
            } else {
                sequencerEngine.loadPreset(
                    preset, true);
            }
        }

        if (!audioUnit) { return; }
        audioUnit.stopSound();
        isPlaying.current = false;

    }, [audioUnit, preset]);

    let thumbStyle = {};
    let thumb = sample && sample.getThumbnail();
    let className = "pack-content";
    if (thumb) {
        thumbStyle.backgroundImage = 'url(' + thumb + ')';
    } else {
        if (sample) {
            thumbStyle.backgroundColor = colors.getColorForHash(sample.getId());
        } else {
            className += " preset";
            thumbStyle.backgroundColor = colors.getColorForHash(name);
        }
    }

        let tags = sample ? sample.tags.slice(0,1) : [];

        if (isCurrent) {
            className += " current";
        }

    if (isSelected) {
        className += " selected";
    }
    if (!name) {
        return '';
    }
    return (
        <div
          draggable={!isEditing}
          onDragOver={e => e.preventDefault()}
          onDragStart={() => {
              if (preset) {
                  setPresetDragging(preset);
              } else {
                  setSampleDragging(sample);
              }
          }}
          onMouseDown={onMouseDown}
          onMouseUp={() => onMouseUp(false)}
          onMouseLeave={() => onMouseUp(true)}
          className={className}>
          <div className="content-thumb" style={thumbStyle}/>
          <div className="content-name">{name.trim()}</div>
          <div className="content-tags">
            {tags.map(x => <div className="content-tag">{x}</div>)}
          </div>
          <div
            onClick={e => e.stopPropagation()}
            onMouseDown={(e) => {
              e.stopPropagation();
              onDelete(sample || preset);
          }} className="delete-btn">x</div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let sequencerEngine = state.sequencer.sequencerEngine; 

    if (sequencerEngine) {
        return {
            sequencerEngine: sequencerEngine 
        };
    } else {
        return {};
    }
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSampleDragging: x => dispatch(setSampleDragging(x)),
      setPresetDragging: x => dispatch(setPresetDragging(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PackContent);
